import React, { useEffect } from 'react';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { Stepper, Step, StepLabel, TextField, Autocomplete, Button, Grid, Snackbar, Card, CardContent, Container, Checkbox, Typography } from "@mui/material";
import Alert from '@mui/material/Alert';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
const styles = {
    root: {
        width: '100%'
    },
};

function SmsCreate() {
    const SessionUser = getUser();

    const steps = ["Şablon Başlık", "Mesaj Metni", "Durumlar", "Ürün Grupları", "Markalar", "Aktif/Pasif Durumu"];
    const [activeStep, setActiveStep] = React.useState(0);
    const [messageBox, setMessageBox] = React.useState('');
    const [messageHeaderBox, setMessageHeaderBox] = React.useState('');
    const [smsDurumlar, setSmsDurumlar] = React.useState([]);
    const [selectedDurum, setSelectedDurum] = React.useState(null);
    const [smsModeller, setSmsModeller] = React.useState([]);
    const [smsMarkaKullanicilar, setSmsMarkaKullanicilarlar] = React.useState([]);
    const [selectedModel, setSelectedModel] = React.useState([]);
    const [selectedMarkaKullanicilar, setSelectedMarkaKullanicilar] = React.useState(null);
    const [messageAktifPasif, setMessageAktifPasif] = React.useState(null);
    const [uyari, setUyari] = React.useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [responseMessage, setresponseMessage] = React.useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const [textFieldError, setTextFieldError] = React.useState(false);
    const [helperText, setHelperText] = React.useState('');


    useEffect(() => {
        getSmsDurumlar();
        getSmsModeller();
        GetSmsMarkaKullanicilar();
    }, []);

    const getSmsDurumlar = () => {
        axios.get("/GetSmsDurumlar").then((response) => {
            setSmsDurumlar(response.data);
        })
    }
    const getSmsModeller = () => {
        axios.get("/GetSmsModeller").then((response) => {
            setSmsModeller(response.data);
        })

    }
    const GetSmsMarkaKullanicilar = () => {
        axios.get("/GetSmsMarkaKullanicilar").then((response) => {
            setSmsMarkaKullanicilarlar(response.data);
        })

    }


    const handleNext = () => {
        if (activeStep === 0 && messageHeaderBox.length <= 0) {
            setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
            setUyariTip("error");
            setUyari(true);
            setTextFieldError(true);
            setHelperText('Lütfen Bu alanı doldurunuz!...');
            return;
        }
        if (activeStep === 1 && messageBox.length <= 0) {
            setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
            setUyariTip("error");
            setUyari(true);
            setTextFieldError(true);
            setHelperText('Lütfen Bu alanı doldurunuz!...');
            return;
        }
        if (activeStep === 2 && selectedDurum === null) {
            setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
            setUyariTip("error");
            setUyari(true);
            return;
        }
        if (activeStep === 3 && selectedModel === null) {
            setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
            setUyariTip("error");
            setUyari(true);
            return;
        }
        if (activeStep === 4 && selectedMarkaKullanicilar.length <= 0) {
            setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
            setUyariTip("error");
            setUyari(true);
            return;
        }
        setTextFieldError(false);
        setHelperText('');
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevStep) => prevStep - 1);
    };

    const aktiflikOptions = [
        { label: 'Aktif', value: 1 },
        { label: 'Pasif', value: 0 },
    ];
    const aktiflikHandleChange = (event, newValue) => {
        setMessageAktifPasif(newValue);
    };

    function SmsOlustur() {
        if (activeStep === 5 && messageAktifPasif === null) {
            setresponseMessage('Lütfen adımları tamamlayıp tekrardan deneyiniz!...')
            setUyariTip("error");
            setUyari(true);
            return;
        }

        var ModelCodes = [];
        selectedModel.map((i) => {
            ModelCodes.push(i.Id);
        })


        const data = {
            MessageHeader: messageHeaderBox?.toString(),
            Status: selectedDurum?.DURUM,
            Active: messageAktifPasif?.value,
            MessageContent: messageBox?.toString(),
            ModelCode: ModelCodes?.toString(),
            TemplateUsersId: selectedMarkaKullanicilar?.ID,
            TemplateUsersDsc: selectedMarkaKullanicilar?.SABLON_ACIKLAMA,
            SessionUser: "" //okta
        }
        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        axios.post('/SmsTemplateCreate', data, config).then(response => {
            setresponseMessage(response.data.ErrorDescription)
            setUyariTip("success");
            setUyari(true);
        });

        // Son adımdan sonra başa sarıyor.
        if (activeStep === steps.length - 1) {
            setActiveStep(0);

            //Field'ların clear işlemi
            setMessageHeaderBox('');
            setMessageBox('');
            setSelectedDurum(null);
            setSelectedModel([]);
            setSelectedMarkaKullanicilar(null);
            setMessageAktifPasif(null);
        }

    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };


    return (
        <>
            <Container maxWidth='xxl' spacing={1} style={{ ...styles.root, marginTop: '10px' }}>
                <Card>
                    <CardContent>
                        <Grid
                            height={'85vh'}
                            size={{
                                xs: 12,
                                sm: 12,
                                md: 12
                            }}>
                            <Snackbar open={uyari} autoHideDuration={2000} onClose={uyariKapat}
                                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                                <Alert onClose={uyariKapat} variant='filled' severity={uyariTip}>
                                    {responseMessage}
                                </Alert>
                            </Snackbar>
                            <Grid container justifyContent="center" spacing={8}>
                                <Grid size={12}>
                                    <Stepper activeStep={activeStep} alternativeLabel>
                                        {steps.map((label) => (
                                            <Step key={label}>
                                                <StepLabel>{label}</StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 8,
                                        md: 6
                                    }}>
                                    <Grid>
                                        {activeStep === 0 && (
                                            <div>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <Typography variant="h6" gutterBottom>
                                                        {'Lütfen Sms Başlığını Giriniz.'}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <TextField
                                                        id='description'
                                                        variant='outlined'
                                                        error={textFieldError}
                                                        helperText={helperText}
                                                        fullWidth
                                                        value={messageHeaderBox}
                                                        onChange={(event) => {
                                                            setMessageHeaderBox(event.target.value);
                                                        }}
                                                    />
                                                </Grid>
                                            </div>
                                        )}
                                        {activeStep === 1 && (
                                            <div>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <Typography variant="h6" gutterBottom>
                                                        {'Lütfen Sms İçeriğini Giriniz.'}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <TextField
                                                        id='description'
                                                        variant='outlined'
                                                        error={textFieldError}
                                                        helperText={helperText}
                                                        fullWidth
                                                        multiline
                                                        minRows={10}
                                                        value={messageBox}
                                                        onChange={(event) => {
                                                            setMessageBox(event.target.value);
                                                        }}
                                                    />
                                                </Grid>
                                            </div>

                                        )}
                                        {activeStep === 2 && (
                                            <div>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <Typography variant="h6" gutterBottom>
                                                        {'Lütfen Durum Seçiniz.'}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <Autocomplete
                                                        disablePortal
                                                        size="small"
                                                        fullWidth
                                                        value={selectedDurum}
                                                        options={smsDurumlar}
                                                        getOptionLabel={(val) => val.ACIKLAMA}
                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                        onChange={(event, newValue) => { setSelectedDurum(newValue) }}
                                                    />
                                                </Grid>
                                            </div>

                                        )}
                                        {activeStep === 3 && (
                                            <div>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <Typography variant="h6" gutterBottom>
                                                        {'Lütfen Ürün Grubu Seçiniz.'}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <Autocomplete
                                                        disablePortal
                                                        size="small"
                                                        fullWidth
                                                        limitTags={1}
                                                        multiple
                                                        disableCloseOnSelect
                                                        value={selectedModel}
                                                        options={smsModeller}
                                                        getOptionLabel={(val) => val.Dsc}
                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                        renderOption={(props, option, { selected }) => (
                                                            <li {...props}>
                                                                <Checkbox
                                                                    icon={icon}
                                                                    checkedIcon={checkedIcon}
                                                                    style={{ marginRight: 8 }}
                                                                    checked={selected}
                                                                />
                                                                {option.Dsc}
                                                            </li>
                                                        )}
                                                        onChange={(event, newValue) => { setSelectedModel(newValue) }}
                                                    />
                                                </Grid>
                                            </div>

                                        )}
                                        {activeStep === 4 && (
                                            <div>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <Typography variant="h6" gutterBottom>
                                                        {'Lütfen Şablon Türü Seçiniz.'}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <Autocomplete
                                                        disablePortal
                                                        size="small"
                                                        fullWidth
                                                        value={selectedMarkaKullanicilar}
                                                        options={smsMarkaKullanicilar}
                                                        getOptionLabel={(val) => val.SABLON_ACIKLAMA}
                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                        onChange={(event, newValue) => { setSelectedMarkaKullanicilar(newValue) }}
                                                    />
                                                </Grid>
                                            </div>

                                        )}
                                        {activeStep === 5 && (
                                            <div>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <Typography variant="h6" gutterBottom>
                                                        {'Lütfen Aktiflik Durumunu Seçiniz.'}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12
                                                    }}>
                                                    <Autocomplete
                                                        disablePortal
                                                        size="small"
                                                        fullWidth
                                                        options={aktiflikOptions}
                                                        value={messageAktifPasif}
                                                        getOptionLabel={(val) => val.label}
                                                        //getOptionSelected={(val) => val.label}
                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                        onChange={aktiflikHandleChange}
                                                    />
                                                </Grid>
                                            </div>

                                        )}
                                        <Grid marginTop={2}>
                                            <Grid>
                                                <Button
                                                    disabled={activeStep === 0}
                                                    size="large"
                                                    onClick={handleBack}
                                                    variant="outlined"
                                                >
                                                    Geri
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    onClick={activeStep === steps.length - 1 ? SmsOlustur : handleNext}
                                                    style={{ marginLeft: 10 }}
                                                >
                                                    {activeStep === steps.length - 1 ? "Bitir" : "İleri"}
                                                </Button>
                                            </Grid>


                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
        </>
    );
}

export default SmsCreate;